/**
 * @param {*} key {String}
 * @param {*} value {String|Object} a storage value
 */
const setItem = (key, value) => localStorage.setItem(key, JSON.stringify(value))

/**
 * @param {*} key {String}
 */
const getItem = (key) => JSON.parse(localStorage.getItem(key))

/**
 * @param {*} key {String}
 */
const removeItem = (key) => localStorage.removeItem(key)

export {
    setItem,
    getItem,
    removeItem,
}
